exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.search-result-item .tag {\n    font-size: 8px;\n    padding: 2px 4px;\n}\n.search-result-item i {\n    font-size: 11px;\n}\n.search-result-item .hit-line {\n    padding-left: 6px;\n}\n.search-result-item .tag.main-tag {\n    font-size: 11px;\n    padding: 4px 8px;\n}\n.search-result-item {\n    padding: 10px 17px;\n    cursor: pointer;\n    border-bottom: 1px solid #eee;\n}\n.search-result-item mark {\n    padding: 0;\n    background-color: #fcf8e3;\n}\n.website-matches {\n    display: block;\n}\n.website-matches.match-count-0 {\n    display: none;\n}\n.search-result-item:hover {\n    background: #eee;\n}\n", ""]);

// exports
